import store from '../store';
import { setDialog } from './dialog';

export const openPushPermissionTeaser = (onConfirm) =>
  store.dispatch(
    setDialog({
      name: 'PushPermissionTeaser',
      open: true,
      hideClose: false,
      dialogProps: {
        maxWidth: 'xs',
        fullWidth: true,
        fullScreenOn: false,
        middle: false,
      },
      actions: [
        {
          children: 'Me notifier',
          variant: 'contained',
          onClick: async (_, close) => {
            close();
            await onConfirm();
          },
        },
      ],
    })
  );
